import Markdown from 'react-markdown';

import { markdownComponents } from './markdownComponents';

interface UserInstructionsProps {
  templateName: string;
  userInstructions: string;
}

/**
 * Displays procedure template user instructions during voice note recording.
 * Shows the template name as a title and renders markdown-formatted instructions.
 */
export const UserInstructions = ({
  templateName,
  userInstructions,
}: UserInstructionsProps) => {
  return (
    <div className="vai-w-2/3 vai-flex vai-flex-col vai-flex-1 vai-min-h-0">
      <h3 className="vai-text-base vai-font-bold vai-text-gray-900 vai-mb-2 vai-flex-shrink-0">
        {templateName}
      </h3>
      <div className="vai-border vai-border-gray-200 vai-rounded-lg vai-bg-white vai-overflow-hidden vai-flex vai-flex-col vai-flex-1 vai-min-h-0">
        <div className="vai-p-4 vai-prose vai-prose-sm vai-text-gray-700 vai-overflow-y-scroll vai-flex-1 vai-min-h-0">
          <Markdown components={markdownComponents}>
            {userInstructions}
          </Markdown>
        </div>
      </div>
    </div>
  );
};
